import config from 'config'
import { selectSkipRefetchCountries } from 'data/selectors'
import type { GetDateKeyOptions } from 'data/types'
import { getRequestParams } from 'data/utils'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import type { NetworkError } from 'utils'
import { fetchAction } from 'utils'

import * as constants from './constants'

const fetchCountries = createLogic<State, GetDateKeyOptions>({
  type: constants.FETCH_COUNTRIES,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const state = getState()
      const baseRequestParams = dateMenuSelectors.baseRequestParams(state, action as any)
      const skipRefetch = selectSkipRefetchCountries(action.payload)(state)

      if (skipRefetch) {
        dispatch({
          type: constants.FETCH_COUNTRIES_DONE,
          payload: action.payload,
        })
      } else {
        const response = await fetchAction(config.api.countries, {
          ...getRequestParams(action as any), // ecoms, necoms, etc.
          ...baseRequestParams,
        })

        dispatch({
          type: constants.FETCH_COUNTRIES_SUCCESS,
          payload: {
            ...action.payload,
            data: response.data,
          },
        })
      }
    } catch (error) {
      dispatch({
        type: constants.FETCH_COUNTRIES_ERROR,
        payload: {
          ...action.payload,
          errorCode: (error as NetworkError)?.response?.status || -1,
        },
      })
    }
    done()
  },
})

export default [fetchCountries]
